import { render } from "./Calendari.vue?vue&type=template&id=209fc3aa"
import script from "./Calendari.vue?vue&type=script&lang=js"
export * from "./Calendari.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__